import React, { useEffect } from "react";
import { Col, Row, Card } from "antd";
import { useParams } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";
import ReactMarkdown from "react-markdown";
import { getImageURL } from "../utils/images";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { noop } from "antd/es/_util/warning";
import { convertToDate } from "../utils/data";

const Post = gql`
    query GetEvent($id: ID!) {
        wbPost(id: $id) {
            data {
                id
                attributes {
                    title
                    publishedAt
                    publishedDate
                    description
                    summary
                    cover {
                        data {
                            attributes {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default function EventsSingle() {
    const location = useLocation();
    const { id } = useParams();
    const { loading, error, data } = useQuery(Post, {
        variables: { id: id },
    });

    useEffect(() => {
        document.body.classList.add("PageEvent");
        return () => {
            document.body.classList.remove("PageEvent");
        };
    }, []);

    useEffect(() => {
        if(data?.wbPost?.data?.attributes?.title) 
            ReactGA.send({ hitType: "pageview", page: location.pathname, title: data.wbPost.data.attributes.title })
    }, [data])

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error :(</p>;

    return (
        <div className="EventsSingle PageSingle">
            <section className="PageHero">
                <div className="AppContainer">
                    {/* <h2 className="title">Events</h2> */}
                    <h1 className="title">{data.wbPost.data.attributes.title}</h1>
                    <div className="CardMeta">
                        <time>
                            {convertToDate(data.wbPost.data.attributes.publishedDate).toLocaleDateString("en-gb", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })}
                        </time>
                    </div>
                </div>
            </section>
            <div className="AppContainer">
                <Row gutter={[20, 0]}>
                    <Col xs={{ span: 24, order: 2 }} md={{ span: 16, order: 1 }}>
                        <Card bordered={false} className="CardItem">
                            <div dangerouslySetInnerHTML={{ __html: data.wbPost.data.attributes.description }}></div>
                        </Card>
                    </Col>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 8, order: 2 }}>
                        <Card
                            bordered={false}
                            className="CardItem Cover"
                            bodyStyle={{ padding: 0 }}
                            cover={<img alt="" src={`${getImageURL(data.wbPost.data.attributes.cover.data?.attributes.url)}`} />}
                        ></Card>
                    </Col>
                </Row>
                {window.location.pathname === '/news-and-insights/8' && (
                    <iframe style={{width: '100%', border: 'none', minHeight: '750px', marginTop: 50}} border="0" src="https://enable.busable.app/timetables/blpctn?rs=01JFV40M3RE4S8GHN8TTKX7Q5T,01JFV56094F0AVD7SHQHVDYFQ6,01JFV6NT48KJDNYF74T5MSSXND,01JFV776A9GVHZSSBB6XC97JSG"></iframe>
                )}
            </div>
        </div>
    );
}
